var map = {
	"./admin/4380-processing.json": 794,
	"./admin/85340-processing-loader.json": 795,
	"./admin/bulk_mail": 478,
	"./admin/bulk_mail.png": 478,
	"./admin/grid4": 479,
	"./admin/grid4.png": 479,
	"./admin/undraw_Conference_speaker_re_1rna": 480,
	"./admin/undraw_Conference_speaker_re_1rna.png": 480,
	"./admin/undraw_blank_canvas_re_2hwy": 481,
	"./admin/undraw_blank_canvas_re_2hwy.svg": 481,
	"./admin/undraw_conference_speaker_re_1rna": 482,
	"./admin/undraw_conference_speaker_re_1rna.svg": 482,
	"./bg1": 483,
	"./bg1.jpg": 483,
	"./digivent/404": 484,
	"./digivent/404.jpg": 484,
	"./digivent/Icon-upload": 485,
	"./digivent/Icon-upload.svg": 485,
	"./digivent/accreditation": 486,
	"./digivent/accreditation.jpg": 486,
	"./digivent/arrow-down": 487,
	"./digivent/arrow-down.png": 487,
	"./digivent/arrow_down": 488,
	"./digivent/arrow_down.svg": 488,
	"./digivent/avatar-placeholder": 489,
	"./digivent/avatar-placeholder.png": 489,
	"./digivent/avatars/AVATAR-01": 490,
	"./digivent/avatars/AVATAR-01.png": 490,
	"./digivent/avatars/AVATAR-02": 491,
	"./digivent/avatars/AVATAR-02.png": 491,
	"./digivent/avatars/AVATAR-03": 492,
	"./digivent/avatars/AVATAR-03.png": 492,
	"./digivent/avatars/AVATAR-04": 493,
	"./digivent/avatars/AVATAR-04.png": 493,
	"./digivent/avatars/AVATAR-05": 494,
	"./digivent/avatars/AVATAR-05.png": 494,
	"./digivent/avatars/AVATAR-06": 495,
	"./digivent/avatars/AVATAR-06.png": 495,
	"./digivent/avatars/AVATAR-07": 496,
	"./digivent/avatars/AVATAR-07.png": 496,
	"./digivent/avatars/AVATAR-08": 497,
	"./digivent/avatars/AVATAR-08.png": 497,
	"./digivent/avatars/AVATAR-09": 498,
	"./digivent/avatars/AVATAR-09.png": 498,
	"./digivent/avatars/AVATAR-10": 499,
	"./digivent/avatars/AVATAR-10.png": 499,
	"./digivent/avatars/AVATAR-11": 500,
	"./digivent/avatars/AVATAR-11.png": 500,
	"./digivent/avatars/AVATAR-12": 501,
	"./digivent/avatars/AVATAR-12.png": 501,
	"./digivent/avatars/AVATAR-13": 502,
	"./digivent/avatars/AVATAR-13.png": 502,
	"./digivent/avatars/AVATAR-14": 503,
	"./digivent/avatars/AVATAR-14.png": 503,
	"./digivent/avatars/AVATAR-15": 504,
	"./digivent/avatars/AVATAR-15.png": 504,
	"./digivent/avatars/AVATAR-16": 505,
	"./digivent/avatars/AVATAR-16.png": 505,
	"./digivent/avatars/AVATAR-17": 506,
	"./digivent/avatars/AVATAR-17.png": 506,
	"./digivent/avatars/AVATAR-18": 507,
	"./digivent/avatars/AVATAR-18.png": 507,
	"./digivent/avatars/AVATAR-19": 508,
	"./digivent/avatars/AVATAR-19.png": 508,
	"./digivent/avatars/AVATAR-20": 509,
	"./digivent/avatars/AVATAR-20.png": 509,
	"./digivent/avatars/AVATAR-21": 510,
	"./digivent/avatars/AVATAR-21.png": 510,
	"./digivent/avatars/AVATAR-22": 511,
	"./digivent/avatars/AVATAR-22.png": 511,
	"./digivent/avatars/AVATAR-23": 512,
	"./digivent/avatars/AVATAR-23.png": 512,
	"./digivent/avatars/AVATAR-24": 513,
	"./digivent/avatars/AVATAR-24.png": 513,
	"./digivent/avatars/AVATAR-25": 514,
	"./digivent/avatars/AVATAR-25.png": 514,
	"./digivent/avatars/AVATAR-26": 515,
	"./digivent/avatars/AVATAR-26.png": 515,
	"./digivent/avatars/AVATAR-27": 516,
	"./digivent/avatars/AVATAR-27.png": 516,
	"./digivent/avatars/AVATAR-28": 517,
	"./digivent/avatars/AVATAR-28.png": 517,
	"./digivent/avatars/AVATAR-29": 518,
	"./digivent/avatars/AVATAR-29.png": 518,
	"./digivent/avatars/AVATAR-30": 519,
	"./digivent/avatars/AVATAR-30.png": 519,
	"./digivent/coffee": 520,
	"./digivent/coffee.jpg": 520,
	"./digivent/digivent": 521,
	"./digivent/digivent.png": 521,
	"./digivent/digivent_bg": 522,
	"./digivent/digivent_bg.jpg": 522,
	"./digivent/digivent_black": 523,
	"./digivent/digivent_black.png": 523,
	"./digivent/digivent_white": 524,
	"./digivent/digivent_white.png": 524,
	"./digivent/facebook_icon": 525,
	"./digivent/facebook_icon.svg": 525,
	"./digivent/fondo_somtalent2": 526,
	"./digivent/fondo_somtalent2.png": 526,
	"./digivent/google_icon": 527,
	"./digivent/google_icon.svg": 527,
	"./digivent/lobby": 528,
	"./digivent/lobby.jpg": 528,
	"./digivent/logo-Mostra-transparente": 529,
	"./digivent/logo-Mostra-transparente.png": 529,
	"./digivent/logo_nomiri": 530,
	"./digivent/logo_nomiri.svg": 530,
	"./dummy": 531,
	"./dummy.png": 531,
	"./image-placeholder": 532,
	"./image-placeholder.jpg": 532,
	"./logo_transparent": 533,
	"./logo_transparent.png": 533,
	"./nomiri-logo": 534,
	"./nomiri-logo.png": 534,
	"./nomiri_og": 535,
	"./nomiri_og.png": 535,
	"./og": 536,
	"./og.png": 536,
	"./order": 231,
	"./order.png": 231,
	"./order.svg": 796,
	"./pause_mode": 537,
	"./pause_mode.png": 537,
	"./rh+": 538,
	"./rh+.png": 538,
	"./video-placeholder": 539,
	"./video-placeholder.jpg": 539,
	"./video-player-placeholder-default": 540,
	"./video-player-placeholder-default.png": 540,
	"./video-story-placeholder-default": 541,
	"./video-story-placeholder-default.png": 541,
	"./web/facebook": 542,
	"./web/facebook.svg": 542,
	"./web/home/index/and_more": 232,
	"./web/home/index/and_more.jpg": 232,
	"./web/home/index/and_more.webp": 797,
	"./web/home/index/bg_hero": 233,
	"./web/home/index/bg_hero.jpg": 233,
	"./web/home/index/bg_hero.webp": 798,
	"./web/home/index/congress": 234,
	"./web/home/index/congress.jpg": 234,
	"./web/home/index/congress.webp": 799,
	"./web/home/index/cultural": 235,
	"./web/home/index/cultural.jpg": 235,
	"./web/home/index/cultural.webp": 800,
	"./web/home/index/customers/brand_1": 543,
	"./web/home/index/customers/brand_1.jpg": 543,
	"./web/home/index/customizable": 236,
	"./web/home/index/customizable.jpg": 236,
	"./web/home/index/customizable.webp": 801,
	"./web/home/index/ease_to_use": 237,
	"./web/home/index/ease_to_use.jpg": 237,
	"./web/home/index/ease_to_use.webp": 802,
	"./web/home/index/employment": 238,
	"./web/home/index/employment.jpg": 238,
	"./web/home/index/employment.webp": 803,
	"./web/home/index/generic": 239,
	"./web/home/index/generic.jpg": 239,
	"./web/home/index/generic.webp": 804,
	"./web/home/index/header_bg": 240,
	"./web/home/index/header_bg.jpg": 240,
	"./web/home/index/header_bg.webp": 805,
	"./web/home/index/header_bg_m": 241,
	"./web/home/index/header_bg_m.jpg": 241,
	"./web/home/index/header_bg_m.webp": 806,
	"./web/home/index/header_bg_t": 242,
	"./web/home/index/header_bg_t.jpg": 242,
	"./web/home/index/header_bg_t.webp": 807,
	"./web/home/index/kind_of_events": 243,
	"./web/home/index/kind_of_events.jpg": 243,
	"./web/home/index/kind_of_events.webp": 808,
	"./web/home/index/music": 244,
	"./web/home/index/music.jpg": 244,
	"./web/home/index/music.webp": 809,
	"./web/home/index/specs/custom": 544,
	"./web/home/index/specs/custom.svg": 544,
	"./web/home/index/specs/exhibitors": 545,
	"./web/home/index/specs/exhibitors.svg": 545,
	"./web/home/index/specs/networking": 546,
	"./web/home/index/specs/networking.svg": 546,
	"./web/home/index/specs/other": 547,
	"./web/home/index/specs/other.svg": 547,
	"./web/home/index/specs/streaming": 548,
	"./web/home/index/specs/streaming.svg": 548,
	"./web/home/index/specs/user": 549,
	"./web/home/index/specs/user.svg": 549,
	"./web/home/index/specs/users": 550,
	"./web/home/index/specs/users.svg": 550,
	"./web/home/index/specs/workshops": 551,
	"./web/home/index/specs/workshops.svg": 551,
	"./web/home/index/theatre": 245,
	"./web/home/index/theatre.jpg": 245,
	"./web/home/index/theatre.webp": 810,
	"./web/home/index/what_is_nomiri": 246,
	"./web/home/index/what_is_nomiri.jpg": 246,
	"./web/home/index/what_is_nomiri.webp": 811,
	"./web/home/platform/header_img": 552,
	"./web/home/platform/header_img.jpg": 552,
	"./web/home/platform/screenshot_1": 553,
	"./web/home/platform/screenshot_1.jpg": 553,
	"./web/home/specs/spec_custom_1": 554,
	"./web/home/specs/spec_custom_1.jpg": 554,
	"./web/home/specs/spec_custom_2": 555,
	"./web/home/specs/spec_custom_2.jpg": 555,
	"./web/home/specs/spec_networking_1": 556,
	"./web/home/specs/spec_networking_1.jpg": 556,
	"./web/home/specs/spec_networking_2": 557,
	"./web/home/specs/spec_networking_2.jpg": 557,
	"./web/home/specs/spec_streaming_1": 558,
	"./web/home/specs/spec_streaming_1.jpg": 558,
	"./web/home/specs/spec_users_1": 559,
	"./web/home/specs/spec_users_1.jpg": 559,
	"./web/home/specs/spec_users_2": 560,
	"./web/home/specs/spec_users_2.jpg": 560,
	"./web/home/specs/spec_workshops_1": 561,
	"./web/home/specs/spec_workshops_1.jpg": 561,
	"./web/instagram": 562,
	"./web/instagram.svg": 562,
	"./web/logo_nomiri": 563,
	"./web/logo_nomiri.svg": 563,
	"./web/twitter": 564,
	"./web/twitter.svg": 564,
	"./web/youtube": 565,
	"./web/youtube.svg": 565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 793;